import { render, staticRenderFns } from "./EstCifras.vue?vue&type=template&id=0a6829a0&"
import script from "./EstCifras.vue?vue&type=script&lang=js&"
export * from "./EstCifras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports